import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
import { WorkoutPreview } from './WorkoutPreview';

interface WorkoutCategoryProps {
  category: {
    id: string;
    name: string;
    description: string;
    icon: React.ReactNode;
    color: string;
  };
  workouts: Array<{
    id: string;
    name: string;
    duration: number;
    strain: number;
    level: string;
    image: string;
    coach: string;
  }>;
  onSelectWorkout: (workoutId: string) => void;
}

export function WorkoutCategory({ category, workouts, onSelectWorkout }: WorkoutCategoryProps) {
  if (!workouts.length) return null;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="relative">
            {category.icon}
            <div className="absolute inset-0 bg-current opacity-20 blur-lg rounded-full" />
          </div>
          <div>
            <h2 className="text-lg font-semibold">{category.name}</h2>
            <p className="text-sm text-muted-foreground">{category.description}</p>
          </div>
        </div>
        <button className="text-sm text-primary hover:text-primary/80 transition-colors flex items-center gap-1">
          View All
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>

      <div className="flex overflow-x-auto gap-4 pb-4 -mx-6 px-6 snap-x snap-mandatory theme-scrollbar">
        {workouts.map((workout) => (
          <motion.div
            key={workout.id}
            className="flex-none w-[300px] snap-start"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <WorkoutPreview
              workout={workout}
              onSelect={() => onSelectWorkout(workout.id)}
            />
          </motion.div>
        ))}
      </div>
    </div>
  );
}